import _ from "lodash";
import { StoreState } from "../index";

export const getAssetInstanceTableDataSelector = (store: StoreState) => {
    return _.get(store, "instanceConfig.instancesTable.tableData", {});
};
